// extracted by mini-css-extract-plugin
export default {"logoutButton":"corner-logout-button_logoutButton__Bv62X"};